<div class="container d-flex flex-column align-items-center">
  <div class="col-6" *ngIf="forms">
    <div
      class="d-flex justify-content-between py-4 align-items-center w-100"
      *ngIf="formType"
    >
      <div class="d-flex flex-column me-2">
        <span> {{ forms[0].available_at | date : "dd/MM/yyyy" }}</span>
        <span class="fw-lighter" style="font-size: 12px"> Fecha Asignado</span>
      </div>

      <div class="d-flex flex-column me-2">
        <span> {{ forms[0].completed_at | date : "dd/MM/yyyy" }}</span>
        <span class="fw-lighter" style="font-size: 12px"> Fecha realizado</span>
      </div>
    </div>

    <div class="d-flex flex-column align-items-center">
      <div
        *ngFor="let response of forms[0].responses; let i = index"
        class="p-3 comparision-block w-100 d-flex flex-column"
      >
        <div class="comparison-question">{{ response.question }}</div>
        <div class="comparison-answers text-center">
          <div>{{ forms[0].responses[i].answer }}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!forms" class="d-flex flex-column align-items-center mt-5">
    <i
      class="bi bi-file-earmark-excel"
      style="font-size: 3rem; color: gray"
    ></i>
    <span class="mt-3">No hay formularios disponibles</span>
  </div>
</div>
